import React, { useEffect } from 'react';
import { useHasMetasiteError } from '../store/appStore';
import { useBiLogger } from '../hooks/useBiLogger/useBiLogger';
import { DsBuilderMethod } from '../types';
import { GeneralError } from '../components/GeneralError/GeneralError';

import { TemplateSelectionRoot } from '../features/templateSelection';

export function TemplateSelection() {
  const metasiteError = useHasMetasiteError();
  const biLogger = useBiLogger();

  useEffect(() => {
    biLogger.pageView(DsBuilderMethod[DsBuilderMethod.TEMPLATE_SELECTION]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (metasiteError) {
    return <GeneralError />;
  }

  return <TemplateSelectionRoot />;
}
